import { AITaskSessionApproval, AITaskSessionStatus, AITaskSessionSummary } from 'models/copilot/aiTaskSession';
import {
  CopilotConversation,
  CopilotConversationContentBlock,
  CopilotConversationItem,
  CopilotDataTableColumn,
  CopilotDataTableContent,
  PromptResponseCitation,
} from 'models/copilot/copilotConversation';
import { CopilotActiveProcessContext } from 'models/copilot/copilotActiveProcessContext';
import {
  CopilotContextProposal,
  CopilotContextProposalItem,
  CopilotContextProposalKind,
  CopilotContextProposalRefusal,
  copilotContextProposalKinds,
  copilotContextRefusalKinds,
} from 'models/copilot/copilotContextProposal';
import { CopilotActiveField, CopilotFieldRef } from 'models/copilot/copilotField';
import { CopilotFileLibrarySaveResult } from 'models/copilot/copilotFileBlock';
import { CopilotGenericContent, CopilotSelectedDocument } from 'models/copilot/copilotGeneric';
import { CopilotOnboardingProject } from 'models/copilot/copilotOnboardingProject';
import { CopilotQuestionOption } from 'models/copilot/copilotQuestionOption';
import { CopilotPanelEntityRef } from 'models/copilot/copilotPanelContextDefinition';
import { CopilotProcessingActivity } from 'models/copilot/copilotProcessingActivity';
import {
  CopilotRiskControlSuggestion,
  CopilotRiskControlSuggestions,
} from 'models/copilot/copilotRiskControlSuggestions';
import { CopilotTaskChecklistSuggestions } from 'models/copilot/copilotTaskChecklistSuggestions';
import {
  TenantProcessStateAnnualPlan,
  TenantProcessStateAnnualPlanDTO,
} from 'models/copilot/Processes/AnnualPlan/tenantProcessStateAnnualPlan';
import {
  AuditFindingOriginal,
  AuditFindingOriginalDTO,
  TenantProcessStateAuditFindings,
  TenantProcessStateAuditFindingsDTO,
} from 'models/copilot/Processes/AuditFindings/tenantProcessStateAuditFindings';
import {
  TenantProcessStateControlDocumentationAudit,
  TenantProcessStateControlDocumentationAuditDTO,
} from 'models/copilot/Processes/ControlDocumentationAudit/copilotControlDocumentationAudit';
import {
  AutomationApprovalState,
  AutomationCandidate,
  AutomationDraftingStage,
  AutomationDraftProposal,
  AutomationDraftState,
  AutomationReadiness,
  AutomationScheduleState,
  AutomationWireState,
  TenantProcessStateAutomationDrafting,
} from 'models/copilot/Processes/AutomationDrafting/tenantProcessStateAutomationDrafting';
import {
  TenantProcessStateControlEvidenceAudit,
  TenantProcessStateControlEvidenceAuditDTO,
} from 'models/copilot/Processes/ControlEvidenceAudit/copilotControlEvidenceAudit';
import { TenantProcessStateAutomationDraftingDTO } from 'models/dto/copilot/tenantProcessStateAutomationDraftingDTO';
import { TenantProcessStateKpiReportDTO } from 'models/dto/copilot/kpiReportProcessStateDTO';
import { TenantProcessStateEntityEvidenceAuditDTO } from 'models/dto/copilot/entityEvidenceAuditProcessStateDTO';
import { EntityEvidenceAuditStage, TenantProcessStateEntityEvidenceAudit } from 'models/copilot/entityEvidenceAudit';
import {
  KpiReportChartKind,
  KpiReportFormat,
  KpiReportStage,
  TenantProcessStateKpiReport,
} from 'models/copilot/kpiReportProcessState';
import {
  ActiveFrameworkAudit,
  ActiveFrameworkAuditDTO,
  IFrameworkAuditItem,
  TenantProcessStateFrameworkAudit,
  TenantProcessStateFrameworkAuditDTO,
} from 'models/copilot/Processes/FrameworkAudit/copilotFrameworkAudit';
import {
  TenantProcessStateLibrary,
  TenantProcessStateLibraryDTO,
} from 'models/copilot/Processes/Library/tenantProcessStateLibrary';
import {
  CopilotProcessSuggestion,
  TenantProcessStateProcessSuggestions,
  TenantProcessStateProcessSuggestionsDTO,
} from 'models/copilot/Processes/ProcessSuggestions/copilotProcessSuggestion';
import {
  TenantProcessStateTaskEvidenceAudit,
  TenantProcessStateTaskEvidenceAuditDTO,
} from 'models/copilot/Processes/TaskEvidenceAudit/copilotTaskEvidenceAudit';
import { TenantProcess, TenantProcessStatus } from 'models/copilot/tenantProcessStateBase';
import { ControlLinkDTO } from 'models/dto/controlLinkDTO';
import {
  AITaskSessionApprovalDTO,
  AITaskSessionDetailDTO,
  AITaskSessionSummaryDTO,
} from 'models/dto/copilot/aiTaskSessionDTO';
import { CopilotContextProposalPayloadDTO } from 'models/dto/copilot/copilotContextProposalDTO';
import { CopilotFieldRefDTO } from 'models/dto/copilot/copilotFieldRefDTO';
import { CopilotFileLibrarySaveResultDTO } from 'models/dto/copilot/copilotFileBlockDTO';
import {
  CopilotConversationContentBlockDTO,
  CopilotConversationDTO,
  CopilotConversationItemDTO,
  CopilotDataTableColumnDTO,
  CopilotDataTableContentDTO,
  PromptResponseCitationDTO,
} from 'models/dto/copilot/copilotConversationDTO';
import {
  CopilotActiveFieldDTO,
  CopilotActiveProcessDTO,
  CopilotGenericContentDTO,
  CopilotSelectedDocumentDTO,
} from 'models/dto/copilot/copilotGenericDTO';
import { CopilotOnboardingProjectDTO } from 'models/dto/copilot/copilotOnboardingProjectDTO';
import { CopilotProcessingActivityDTO } from 'models/dto/copilot/copilotProcessingActivityDTO';
import { CopilotQuestionOptionDTO } from 'models/dto/copilot/copilotQuestionOptionDTO';
import {
  CopilotRiskControlSuggestionsDTO,
  CopilotRiskControlSuggestionsRequestDTO,
} from 'models/dto/copilot/copilotRiskControlSuggestionsDTO';
import {
  CopilotTaskChecklistSuggestionsDTO,
  CopilotTaskChecklistSuggestionsRequestDTO,
} from 'models/dto/copilot/copilotTaskChecklistSuggestionsDTO';
import { TenantProcessStateBaseDTO } from 'models/dto/copilot/tenantProcessStateBaseDTO';
import IdListDTO from 'models/dto/IdListDTO';
import { EntityTypes } from 'models/entity';
import GlobalDataCache from 'models/globalDataCache/globalDataCache';
import Process from 'models/process/process';
import { PrivacyFramework } from 'models/processingActivity';
import ResourceLink from 'models/resourceLink';
import ResourceList from 'models/resourceList';
import Task from 'models/tasks/task';
import { fromApiDateTimeOptional, toApiDateTimeOptional } from 'utils/datetime';
import { mapFromControls } from './controlMappings';
import { mapFromDashboard } from './dashboardMapping';
import { mapFromResourceLinks, mapToResourceLinks } from './linkMapping';
import { mapFromResourceList, mapToResourceList } from './listMapping';
import { mapFromTags } from './tagMapping';
import { mapFromTasksArray, mapToTasksArray } from './taskMapping';

export function mapToCopilotConversation(item: CopilotConversation): CopilotConversationDTO {
  const output = new CopilotConversationDTO();
  output.id = item.id;
  output.request = mapToCopilotConversationItem(item.request);
  output.thread = mapToCopilotConversationItems(item.thread);

  return output;
}

export function mapToCopilotConversationItems(items: CopilotConversationItem[]): CopilotConversationItemDTO[] {
  return items.map((item) => {
    return mapToCopilotConversationItem(item);
  }) as CopilotConversationItemDTO[];
}

export function mapToCopilotConversationItem(
  item: CopilotConversationItem | undefined,
): CopilotConversationItemDTO | undefined {
  if (!item) return undefined;
  const output = new CopilotConversationItemDTO();
  output.id = item.id;
  output.type = item.type;
  output.date = toApiDateTimeOptional(item.date);
  output.userId = item.userId;
  output.question = item.question;
  output.context = item.context;
  output.promptType = item.promptType;
  output.response = item.response;
  output.selectedEntityIds = item.selectedEntityIds
    ? new IdListDTO(item.selectedEntityIds.map((id) => id.toString()))
    : undefined;
  output.link = item.link;
  output.contentBlocks = mapToCopilotContentBlocks(item.contentBlocks);

  return output;
}

export function mapFromCopilotConversation(item: CopilotConversationDTO): CopilotConversation {
  const output = new CopilotConversation();
  if (!item) return output;
  output.id = item.id;
  output.request = mapFromCopilotConversationItem(item.request);
  output.thread = mapFromCopilotConversationItems(item.thread);

  return output;
}

export function mapFromCopilotConversationItems(items: CopilotConversationItemDTO[]): CopilotConversationItem[] {
  if (!items) return [];

  return items.map((item) => {
    return mapFromCopilotConversationItem(item);
  }) as CopilotConversationItem[];
}

export function mapFromCopilotConversationItem(
  item: CopilotConversationItemDTO | undefined,
): CopilotConversationItem | undefined {
  if (!item) return undefined;
  const output = new CopilotConversationItem();
  output.id = item.id;
  output.type = item.type;
  output.date = fromApiDateTimeOptional(item.date);
  output.userId = item.userId;
  output.question = item.question;
  output.context = item.context;
  output.promptType = item.promptType;
  output.response = item.response;
  output.citations = mapFromPromptResponseCitations(item.citations);
  output.metadata = item.metadata;
  output.selectedEntityIds = item.selectedEntityIds?.idList?.map<number>((i) => Number(i)) ?? undefined;
  output.link = item.link;
  output.contentBlocks = mapFromCopilotContentBlocks(item.contentBlocks);

  return output;
}

function mapToCopilotContentBlocks(
  items: CopilotConversationContentBlock[] | undefined,
): CopilotConversationContentBlockDTO[] | undefined {
  if (!items) return undefined;

  return items.map((item) => {
    const output = new CopilotConversationContentBlockDTO();
    output.id = item.id;
    output.kind = item.kind;
    output.version = item.version;
    output.created = toApiDateTimeOptional(item.created);
    output.title = item.title;
    output.text = item.text;
    output.link = item.link;
    output.savedLibraryListId = item.savedLibraryListId;
    output.savedLibraryLinkId = item.savedLibraryLinkId;
    output.adaptiveCardJson = item.adaptiveCardJson;
    output.dataTable = mapToCopilotDataTable(item.dataTable);
    output.adaptiveInputs = item.adaptiveInputs;
    output.payload = item.payload;
    output.mimeType = item.mimeType;
    output.sourceUrl = item.sourceUrl;

    return output;
  });
}

function mapFromCopilotContentBlocks(
  items: CopilotConversationContentBlockDTO[] | undefined,
): CopilotConversationContentBlock[] | undefined {
  if (!items) return undefined;

  return items.map((item) => {
    const output = new CopilotConversationContentBlock();
    output.id = item.id;
    output.kind = item.kind;
    output.version = item.version ?? 0;
    output.created = fromApiDateTimeOptional(item.created);
    output.title = item.title;
    output.text = item.text;
    output.link = item.link;
    output.savedLibraryListId = item.savedLibraryListId;
    output.savedLibraryLinkId = item.savedLibraryLinkId;
    output.adaptiveCardJson = item.adaptiveCardJson;
    output.dataTable = mapFromCopilotDataTable(item.dataTable);
    output.adaptiveInputs = item.adaptiveInputs;
    output.payload = item.payload;
    output.mimeType = item.mimeType;
    output.sourceUrl = item.sourceUrl;

    return output;
  });
}

function mapToCopilotDataTable(item: CopilotDataTableContent | undefined): CopilotDataTableContentDTO | undefined {
  if (!item) return undefined;
  const output = new CopilotDataTableContentDTO();
  output.columns = item.columns.map((column) => {
    const mapped = new CopilotDataTableColumnDTO();
    mapped.key = column.key;
    mapped.name = column.name;
    mapped.dataType = column.dataType;

    return mapped;
  });
  output.rows = item.rows.map((row) => ({ ...row }));
  output.page = item.page;
  output.pageSize = item.pageSize;
  output.totalCount = item.totalCount;
  output.returnedCount = item.returnedCount;
  output.isTruncated = item.isTruncated;
  output.maxReturnedRows = item.maxReturnedRows;

  return output;
}

function mapFromCopilotDataTable(item: CopilotDataTableContentDTO | undefined): CopilotDataTableContent | undefined {
  if (!item) return undefined;
  const output = new CopilotDataTableContent();
  output.columns = item.columns.map((column) => {
    const mapped = new CopilotDataTableColumn();
    mapped.key = column.key;
    mapped.name = column.name;
    mapped.dataType = column.dataType;

    return mapped;
  });
  output.rows = item.rows.map((row) => ({ ...row }));
  output.page = item.page;
  output.pageSize = item.pageSize;
  output.totalCount = item.totalCount;
  output.returnedCount = item.returnedCount ?? item.rows.length;
  output.isTruncated = item.isTruncated ?? false;
  output.maxReturnedRows = item.maxReturnedRows ?? 0;

  return output;
}

//
// Risk
//
export function mapToCopilotRiskControlSuggestionsRequest(riskId: number): CopilotRiskControlSuggestionsRequestDTO {
  const output = new CopilotRiskControlSuggestionsRequestDTO();
  output.riskId = riskId;

  return output;
}

export function mapFromCopilotRiskControlSuggestions(
  item: CopilotRiskControlSuggestionsDTO,
): CopilotRiskControlSuggestions {
  const output = new CopilotRiskControlSuggestions();
  output.controls = (item.controls ?? []).map((control) => {
    const suggestion = new CopilotRiskControlSuggestion();
    suggestion.controlId = control.controlId;
    suggestion.code = control.code ?? '';
    suggestion.name = control.name ?? '';

    return suggestion;
  });

  return output;
}

//
// Task
//
export function mapToCopilotTaskChecklistSuggestionsRequest(
  name: string,
  description: string,
  steps: string[],
): CopilotTaskChecklistSuggestionsRequestDTO {
  const output = new CopilotTaskChecklistSuggestionsRequestDTO();
  output.name = name;
  output.description = description;
  output.steps = [...steps];

  return output;
}

export function mapFromCopilotTaskChecklistSuggestions(
  item: CopilotTaskChecklistSuggestionsDTO,
): CopilotTaskChecklistSuggestions {
  const output = new CopilotTaskChecklistSuggestions();
  output.steps = (item.steps ?? []).filter((step) => !!step?.trim());
  output.message = item.message || undefined;

  return output;
}

//
// Onboarding project
//
export function mapFromCopilotOnboardingProject(
  item: CopilotOnboardingProjectDTO,
  cache: GlobalDataCache,
): CopilotOnboardingProject {
  const output = new CopilotOnboardingProject();
  output.tasks = mapFromTasksArray(item.tasks, cache);
  output.tags = mapFromTags(item.tags);
  output.projectDocument = item.projectDocument;
  output.dashboard = item.dashboard ? mapFromDashboard(item.dashboard, cache) : undefined;
  output.previewPackageInstalled = item.previewPackageInstalled;
  output.projectMilestonesCreated = item.projectMilestonesCreated;

  return output;
}

//
// Tenant Process State
//
export function mapToTenantProcessState(
  processId: TenantProcess,
  typeOfEntity: number,
  entityId: number,
): TenantProcessStateBaseDTO {
  const output = new TenantProcessStateBaseDTO();
  output.processId = processId;
  output.typeOfEntity = typeOfEntity;
  output.entityId = entityId;

  return output;
}

//
// Annual plan
//
export function mapFromTenantProcessStateAnnualPlan(
  item: TenantProcessStateBaseDTO,
  globalDataCache: GlobalDataCache,
): TenantProcessStateAnnualPlan {
  const data = JSON.parse(item.data || '{}') as TenantProcessStateAnnualPlanDTO;
  const output = new TenantProcessStateAnnualPlan();
  output.tasks = mapFromTasksArray(data.tasks, globalDataCache);
  output.controls = mapFromControls(data.controls, globalDataCache);
  output.conversation = mapFromCopilotConversation(data.conversation);

  return output;
}

export function mapToTenantProcessStateAnnualPlan(
  conversation: CopilotConversation,
  status: TenantProcessStatus,
  tasks: Task[],
): TenantProcessStateBaseDTO {
  const data = new TenantProcessStateAnnualPlanDTO();
  data.conversation = mapToCopilotConversation(conversation);
  data.tasks = mapToTasksArray(tasks);

  const output = new TenantProcessStateBaseDTO();
  output.processId = TenantProcess.AnnualPlan;
  output.status = status;
  output.data = JSON.stringify(data);

  return output;
}

//
// Audit findings
//
export function mapFromTenantProcessStateAuditFindings(
  item: TenantProcessStateBaseDTO,
  globalDataCache: GlobalDataCache,
): TenantProcessStateAuditFindings {
  const data = JSON.parse(item.data || '{}') as TenantProcessStateAuditFindingsDTO;
  const output = new TenantProcessStateAuditFindings();
  output.internalAuditId = data.internalAuditId ?? item.entityId ?? 0;
  output.newTasks = mapFromTasksArray(data.newTasks, globalDataCache);
  output.updatedTasks = mapFromTasksArray(data.updatedTasks, globalDataCache);
  output.eligibleTemplateIds = data.eligibleTemplateIds ?? [];
  //carried from the envelope, not from the data blob: the server owns the process status
  output.status = item.status ?? TenantProcessStatus.InProgress;
  output.originals = (data.originals ?? []).map((originalDTO) => {
    const original = new AuditFindingOriginal();
    original.taskId = originalDTO.taskId;
    original.name = originalDTO.name;
    original.description = originalDTO.description;
    original.checkList = originalDTO.checkList;
    original.tagIds = originalDTO.tagIds?.idList?.map<number>((id) => Number(id)) ?? [];

    return original;
  });
  output.conversation = mapFromCopilotConversation(data.conversation);

  return output;
}

export function mapToTenantProcessStateAuditFindings(
  conversation: CopilotConversation,
  status: TenantProcessStatus,
  internalAuditId: number,
  newTasks: Task[],
  updatedTasks: Task[],
  originals: AuditFindingOriginal[],
): TenantProcessStateBaseDTO {
  const data = new TenantProcessStateAuditFindingsDTO();
  data.internalAuditId = internalAuditId;
  data.newTasks = mapToTasksArray(newTasks);
  data.updatedTasks = mapToTasksArray(updatedTasks);
  data.conversation = mapToCopilotConversation(conversation);
  data.originals = originals.map((original) => {
    const originalDTO = new AuditFindingOriginalDTO();
    originalDTO.taskId = original.taskId;
    originalDTO.name = original.name;
    originalDTO.description = original.description;
    originalDTO.checkList = original.checkList;
    originalDTO.tagIds = new IdListDTO(original.tagIds.map((id) => id.toString()));

    return originalDTO;
  });

  const output = new TenantProcessStateBaseDTO();
  output.processId = TenantProcess.AuditFindings;
  //the proposal belongs to this audit: every audit keeps its own, and the panel picks it up again
  output.typeOfEntity = EntityTypes.InternalAudit;
  output.entityId = internalAuditId;
  output.status = status;
  output.data = JSON.stringify(data);

  return output;
}

//
// Library
//
export function mapFromTenantProcessStateLibrary(
  item: TenantProcessStateBaseDTO,
  cache: GlobalDataCache,
): TenantProcessStateLibrary {
  const data = JSON.parse(item.data || '{}') as TenantProcessStateLibraryDTO;
  const output = new TenantProcessStateLibrary();
  const lists = data.lists?.map((list) => mapFromResourceList(list)) ?? [];
  output.conversation = mapFromCopilotConversation(data.conversation);
  output.links = mapFromResourceLinks(data.links, cache);
  output.links.forEach((link) => {
    const list = lists.find((item) => item.listId === link.listId);
    if (list) {
      link.list = list;
    }
  });
  output.lists = lists;
  output.controlLinks = data.controlLinks;

  return output;
}

export function mapToTenantProcessStateLibrary(
  conversation: CopilotConversation,
  links: ResourceLink[],
  lists: ResourceList[],
  controlLinks: ControlLinkDTO[],
  status: TenantProcessStatus,
): TenantProcessStateBaseDTO {
  const data = new TenantProcessStateLibraryDTO();
  data.conversation = mapToCopilotConversation(conversation);
  data.links = mapToResourceLinks(links, false) ?? [];
  data.lists = lists.map((list) => mapToResourceList(list)) ?? [];
  data.controlLinks = controlLinks;

  const output = new TenantProcessStateBaseDTO();
  output.processId = TenantProcess.Library;
  output.status = status;
  output.data = JSON.stringify(data);

  return output;
}

//
// Process suggestions
//
export function mapFromTenantProcessStateProcessSuggestions(
  item: TenantProcessStateBaseDTO,
): TenantProcessStateProcessSuggestions {
  const data = JSON.parse(item.data || '{}') as TenantProcessStateProcessSuggestionsDTO;
  const output = new TenantProcessStateProcessSuggestions();
  output.conversation = mapFromCopilotConversation(data.conversation);
  output.processes = mapFromCopilotProcessSuggestions(data.processes);
  output.currentProcesses = mapFromCopilotProcessSuggestions(data.currentProcesses);
  output.createdProcesses = mapFromCopilotProcessSuggestions(data.createdProcesses);

  return output;
}

export function mapToTenantProcessStateProcessSuggestions(
  conversation: CopilotConversation,
  status: TenantProcessStatus,
  processes: CopilotProcessSuggestion[],
  currentProcesses: CopilotProcessSuggestion[],
): TenantProcessStateBaseDTO {
  const data = new TenantProcessStateProcessSuggestionsDTO();
  data.conversation = mapToCopilotConversation(conversation);
  data.processes = processes.map((process) => mapToCopilotProcessSuggestion(process));
  data.currentProcesses = currentProcesses.map((process) => mapToCopilotProcessSuggestion(process));

  const output = new TenantProcessStateBaseDTO();
  output.processId = TenantProcess.ProcessSuggestions;
  output.status = status;
  output.data = JSON.stringify(data);

  return output;
}

//
// Framework audit
//
export function mapFromTenantProcessStateFrameworkAudit(
  item: TenantProcessStateBaseDTO,
): TenantProcessStateFrameworkAudit {
  const data = JSON.parse(item.data || '{}') as TenantProcessStateFrameworkAuditDTO & {
    standardName?: string;
    items?: IFrameworkAuditItem[];
    reportLinkId?: number;
    reportLinkName?: string;
    reportLinkUrl?: string;
  };
  const output = new TenantProcessStateFrameworkAudit();
  output.isoNormId = data.isoNormId ?? item.entityId;
  output.standardName = data.standardName ?? '';
  output.includeDocumentation = data.includeDocumentation ?? true;
  output.includeEvidence = data.includeEvidence ?? true;
  // Missing means the run predates the option: mailing the requestor was the behaviour then.
  output.sendCompletionEmail = data.sendCompletionEmail ?? true;
  output.items = data.items ?? [];
  output.reportLinkId = data.reportLinkId ?? undefined;
  output.reportLinkName = data.reportLinkName ?? '';
  output.reportLinkUrl = data.reportLinkUrl ?? '';
  output.conversation = mapFromCopilotConversation(data.conversation);

  return output;
}

export function mapToTenantProcessStateFrameworkAudit(
  conversation: CopilotConversation,
  status: TenantProcessStatus,
  isoNormId: number,
  includeDocumentation: boolean,
  includeEvidence: boolean,
  sendCompletionEmail: boolean,
): TenantProcessStateBaseDTO {
  const data = new TenantProcessStateFrameworkAuditDTO();
  data.isoNormId = isoNormId;
  data.includeDocumentation = includeDocumentation;
  data.includeEvidence = includeEvidence;
  data.sendCompletionEmail = sendCompletionEmail;
  data.conversation = mapToCopilotConversation(conversation);

  const output = new TenantProcessStateBaseDTO();
  output.processId = TenantProcess.FrameworkAudit;
  output.typeOfEntity = EntityTypes.Standard;
  output.entityId = isoNormId;
  output.status = status;
  output.data = JSON.stringify(data);

  return output;
}

export function mapFromActiveFrameworkAudit(dto: ActiveFrameworkAuditDTO): ActiveFrameworkAudit {
  const output = new ActiveFrameworkAudit();
  output.isoNormId = dto.isoNormId;
  output.standardName = dto.standardName ?? '';
  output.status = dto.status;

  return output;
}

//
// Control evidence audit
//
export function mapFromTenantProcessStateControlEvidenceAudit(
  item: TenantProcessStateBaseDTO,
): TenantProcessStateControlEvidenceAudit {
  const data = JSON.parse(item.data || '{}') as TenantProcessStateControlEvidenceAuditDTO;
  const output = new TenantProcessStateControlEvidenceAudit();
  output.controlId = data.controlId ?? item.entityId;
  output.selectedRecommendationIds = data.selectedRecommendationIds ?? [];
  output.createdTaskIds = data.createdTaskIds ?? [];
  output.conversation = mapFromCopilotConversation(data.conversation);
  output.normIds = data.normIds ?? [];

  return output;
}

export function mapToTenantProcessStateControlEvidenceAudit(
  conversation: CopilotConversation,
  status: TenantProcessStatus,
  controlId: number,
  createdTaskIds: number[],
  periodStart?: string,
  periodEnd?: string,
  normIds?: number[],
): TenantProcessStateBaseDTO {
  const data = new TenantProcessStateControlEvidenceAuditDTO();
  data.controlId = controlId;
  data.selectedRecommendationIds = [];
  data.createdTaskIds = createdTaskIds;
  data.conversation = mapToCopilotConversation(conversation);
  data.periodStart = periodStart;
  data.periodEnd = periodEnd;
  data.normIds = normIds;

  const output = new TenantProcessStateBaseDTO();
  output.processId = TenantProcess.ControlEvidenceAudit;
  output.typeOfEntity = EntityTypes.Control;
  output.entityId = controlId;
  output.status = status;
  output.data = JSON.stringify(data);

  return output;
}

//
// Automation drafting (phase 27)
//
export function mapFromTenantProcessStateAutomationDrafting(
  item: TenantProcessStateBaseDTO,
): TenantProcessStateAutomationDrafting {
  const data = JSON.parse(item.data || '{}') as TenantProcessStateAutomationDraftingDTO;
  const output = new TenantProcessStateAutomationDrafting();
  output.status = item.status;
  output.stage = data.stage ?? AutomationDraftingStage.Proposal;
  output.inputAllowed = data.inputAllowed === true;
  output.actions = data.actions ?? [];
  output.entityType = data.entityType ?? item.typeOfEntity;
  output.entityId = data.entityId ?? item.entityId;
  output.entityCode = data.entityCode;
  output.candidates = (data.candidates ?? []).map((candidate) => {
    const result = new AutomationCandidate();
    result.id = candidate.id ?? '';
    result.title = candidate.title ?? '';
    result.proves = candidate.proves ?? '';
    result.evidenceSource = candidate.evidenceSource ?? '';
    result.kind = candidate.kind ?? 'pass_fail';
    result.checkKey = candidate.checkKey ?? '';
    result.readiness = candidate.readiness ?? AutomationReadiness.Ready;
    result.capabilityKey = candidate.capabilityKey;
    result.missingCapabilities = candidate.missingCapabilities ?? [];
    result.existingSkillKey = candidate.existingSkillKey;

    return result;
  });
  output.selectedCandidateId = data.selectedCandidateId;
  if (data.draft) {
    const draft = new AutomationDraftState();
    if (data.draft.proposal) {
      const proposal = new AutomationDraftProposal();
      proposal.isRevision = data.draft.proposal.isRevision === true;
      proposal.key = data.draft.proposal.key;
      proposal.name = data.draft.proposal.name;
      proposal.description = data.draft.proposal.description;
      proposal.category = data.draft.proposal.category;
      proposal.skillMd = data.draft.proposal.skillMd ?? '';
      proposal.skillYaml = data.draft.proposal.skillYaml ?? '';
      proposal.changeSummary = data.draft.proposal.changeSummary;
      proposal.proposedVersion = data.draft.proposal.proposedVersion;
      proposal.notes = data.draft.proposal.notes ?? [];
      proposal.yamlErrors = data.draft.proposal.yamlErrors ?? [];
      draft.proposal = proposal;
    }
    draft.skillId = data.draft.skillId;
    draft.versionId = data.draft.versionId;
    draft.version = data.draft.version;
    draft.versionStatus = data.draft.versionStatus;
    draft.skillKey = data.draft.skillKey;
    draft.skillName = data.draft.skillName;
    draft.testCaseCount = data.draft.testCaseCount ?? 0;
    draft.lastTestOutcome = data.draft.lastTestOutcome;
    output.draft = draft;
  }
  if (data.approval) {
    const approval = new AutomationApprovalState();
    approval.submitted = data.approval.submitted === true;
    approval.versionStatus = data.approval.versionStatus;
    approval.approved = data.approval.approved === true;
    approval.published = data.approval.published === true;
    approval.needsAdmin = data.approval.needsAdmin === true;
    approval.reason = data.approval.reason;
    output.approval = approval;
  }
  if (data.wire) {
    const wire = new AutomationWireState();
    wire.wired = data.wire.wired === true;
    wire.integrationId = data.wire.integrationId ?? 0;
    wire.kpiId = data.wire.kpiId ?? 0;
    wire.checkKey = data.wire.checkKey;
    wire.kpiName = data.wire.kpiName;
    wire.error = data.wire.error;
    output.wire = wire;
  }
  if (data.schedule) {
    const schedule = new AutomationScheduleState();
    schedule.choice = data.schedule.choice;
    schedule.scheduleId = data.schedule.scheduleId;
    schedule.error = data.schedule.error;
    output.schedule = schedule;
  }
  output.conversation = mapFromCopilotConversation(data.conversation);

  return output;
}

// The request state: the conversation (with the answered cards) and the stage command; the server fills the rest.
// typeOfEntity/entityId key the row on the control or requirement (NotSet/0 from the annual plan).
export function mapToTenantProcessStateAutomationDrafting(
  conversation: CopilotConversation,
  status: TenantProcessStatus,
  entityType: number,
  entityId: number,
  command?: string,
): TenantProcessStateBaseDTO {
  const data = new TenantProcessStateAutomationDraftingDTO();
  data.conversation = mapToCopilotConversation(conversation);
  data.command = command;

  const output = new TenantProcessStateBaseDTO();
  output.processId = TenantProcess.AutomationDrafting;
  output.typeOfEntity = entityType;
  output.entityId = entityId;
  output.status = status;
  output.data = JSON.stringify(data);

  return output;
}

//
// KPI report (PLAN-070)
//
export function mapFromTenantProcessStateKpiReport(item: TenantProcessStateBaseDTO): TenantProcessStateKpiReport {
  const data = JSON.parse(item.data || '{}') as TenantProcessStateKpiReportDTO;
  const output = new TenantProcessStateKpiReport();
  output.status = item.status;
  output.entityId = item.entityId;
  output.stage = data.stage ?? KpiReportStage.GatherInputs;
  output.jobId = data.jobId ?? undefined;
  output.reservationId = data.reservationId ?? undefined;
  output.contextKey = data.contextKey ?? undefined;
  output.format = data.format === null || data.format === undefined ? undefined : (data.format as KpiReportFormat);
  output.kpiIds = data.kpiIds ?? [];
  output.start = fromApiDateTimeOptional(data.start);
  output.end = fromApiDateTimeOptional(data.end);
  output.instructions = data.instructions ?? undefined;
  output.chartKinds = (data.chartKinds ?? []).map((chart) => {
    const result = new KpiReportChartKind();
    result.kpiId = chart.kpiId ?? 0;
    result.kind = chart.kind ?? '';

    return result;
  });
  output.notes = data.notes ?? undefined;
  output.conversation = mapFromCopilotConversation(data.conversation);
  output.fileBlockId = data.fileBlockId ?? undefined;
  output.traceId = data.traceId ?? undefined;
  output.sessionId = data.sessionId ?? undefined;

  return output;
}

// The request state: the conversation (with the answered card) and, on a start, what the caller knows: the finished
// data report job (the modal) or the selected KPIs (the scene action). The server owns the row key: the request sends
// 0 and the inputs, the answer carries the key (TenantProcessStateKpiReport.entityId).
export function mapToTenantProcessStateKpiReport(
  conversation: CopilotConversation,
  status: TenantProcessStatus,
  jobId?: number,
  kpiIds?: number[],
  reservationId?: string,
  contextKey?: string,
  format?: number,
): TenantProcessStateBaseDTO {
  const data = new TenantProcessStateKpiReportDTO();
  data.conversation = mapToCopilotConversation(conversation);
  data.jobId = jobId;
  data.kpiIds = kpiIds;
  data.reservationId = reservationId;
  data.contextKey = contextKey;
  data.format = format;

  const output = new TenantProcessStateBaseDTO();
  output.processId = TenantProcess.KpiReport;
  output.typeOfEntity = 0;
  output.entityId = 0;
  output.status = status;
  output.data = JSON.stringify(data);

  return output;
}

//
// Entity evidence audit (PLAN-077)
//
export function mapFromTenantProcessStateEntityEvidenceAudit(
  item: TenantProcessStateBaseDTO,
): TenantProcessStateEntityEvidenceAudit {
  const data = JSON.parse(item.data || '{}') as TenantProcessStateEntityEvidenceAuditDTO;
  const output = new TenantProcessStateEntityEvidenceAudit();
  output.status = item.status;
  output.entityType = data.entityType ?? item.typeOfEntity;
  output.entityId = data.entityId ?? item.entityId;
  output.entityName = data.entityName ?? undefined;
  output.stage = data.stage ?? EntityEvidenceAuditStage.Preparing;
  output.force = data.force ?? false;
  output.consumerTaskId = data.consumerTaskId ?? undefined;
  output.reportMarkdown = data.reportMarkdown ?? undefined;
  output.appliedTaskId = data.appliedTaskId ?? undefined;
  output.unchangedSince = fromApiDateTimeOptional(data.unchangedSince);
  output.traceId = data.traceId ?? undefined;
  output.conversation = mapFromCopilotConversation(data.conversation);

  return output;
}

// The request state: the conversation and, on a start, Force (Run again on an unchanged entity); keyed on the entity
export function mapToTenantProcessStateEntityEvidenceAudit(
  conversation: CopilotConversation,
  status: TenantProcessStatus,
  entityType: EntityTypes,
  entityId: number,
  force: boolean,
): TenantProcessStateBaseDTO {
  const data = new TenantProcessStateEntityEvidenceAuditDTO();
  data.entityType = entityType;
  data.entityId = entityId;
  data.force = force;
  data.conversation = mapToCopilotConversation(conversation);

  const output = new TenantProcessStateBaseDTO();
  output.processId = TenantProcess.EntityEvidenceAudit;
  output.typeOfEntity = entityType;
  output.entityId = entityId;
  output.status = status;
  output.data = JSON.stringify(data);

  return output;
}

//
// Control documentation audit
//
export function mapFromTenantProcessStateControlDocumentationAudit(
  item: TenantProcessStateBaseDTO,
): TenantProcessStateControlDocumentationAudit {
  const data = JSON.parse(item.data || '{}') as TenantProcessStateControlDocumentationAuditDTO;
  const output = new TenantProcessStateControlDocumentationAudit();
  output.controlId = data.controlId ?? item.entityId;
  output.selectedRecommendationIds = data.selectedRecommendationIds ?? [];
  output.createdTaskIds = data.createdTaskIds ?? [];
  output.conversation = mapFromCopilotConversation(data.conversation);
  output.normIds = data.normIds ?? [];

  return output;
}

export function mapToTenantProcessStateControlDocumentationAudit(
  conversation: CopilotConversation,
  status: TenantProcessStatus,
  controlId: number,
  createdTaskIds: number[],
  periodStart?: string,
  periodEnd?: string,
  normIds?: number[],
): TenantProcessStateBaseDTO {
  const data = new TenantProcessStateControlDocumentationAuditDTO();
  data.controlId = controlId;
  data.selectedRecommendationIds = [];
  data.createdTaskIds = createdTaskIds;
  data.conversation = mapToCopilotConversation(conversation);
  data.periodStart = periodStart;
  data.periodEnd = periodEnd;
  data.normIds = normIds;

  const output = new TenantProcessStateBaseDTO();
  output.processId = TenantProcess.ControlDocumentationAudit;
  output.typeOfEntity = EntityTypes.Control;
  output.entityId = controlId;
  output.status = status;
  output.data = JSON.stringify(data);

  return output;
}

//
// Task evidence audit
//
export function mapFromTenantProcessStateTaskEvidenceAudit(
  item: TenantProcessStateBaseDTO,
): TenantProcessStateTaskEvidenceAudit {
  const data = JSON.parse(item.data || '{}') as TenantProcessStateTaskEvidenceAuditDTO;
  const output = new TenantProcessStateTaskEvidenceAudit();
  output.taskId = data.taskId ?? item.entityId;
  output.conversation = mapFromCopilotConversation(data.conversation);

  return output;
}

export function mapToTenantProcessStateTaskEvidenceAudit(
  conversation: CopilotConversation,
  status: TenantProcessStatus,
  taskId: number,
): TenantProcessStateBaseDTO {
  const data = new TenantProcessStateTaskEvidenceAuditDTO();
  data.taskId = taskId;
  data.conversation = mapToCopilotConversation(conversation);

  const output = new TenantProcessStateBaseDTO();
  output.processId = TenantProcess.TaskEvidenceAudit;
  output.typeOfEntity = EntityTypes.Task;
  output.entityId = taskId;
  output.status = status;
  output.data = JSON.stringify(data);

  return output;
}

export function mapProcessToCopilotProcessSuggestion(process: Process): CopilotProcessSuggestion {
  const output = new CopilotProcessSuggestion();
  output.processId = process.processId;
  output.parentProcessId = process.parentProcessId;
  output.uniqueCode = process.code;
  output.state = process.state?.toString();
  output.name = process.name;
  output.description = process.description;

  return output;
}

function mapFromCopilotProcessSuggestions(
  processes: CopilotProcessSuggestion[] | undefined,
): CopilotProcessSuggestion[] {
  if (!processes) return [];

  return processes.map((process) => {
    const output = new CopilotProcessSuggestion();
    output.processId = process.processId;
    output.parentProcessId = process.parentProcessId;
    output.uniqueCode = process.uniqueCode;
    output.state = process.state;
    output.name = process.name;
    output.description = process.description;

    return output;
  });
}

function mapToCopilotProcessSuggestion(process: CopilotProcessSuggestion): CopilotProcessSuggestion {
  const output = new CopilotProcessSuggestion();
  output.processId = process.processId;
  output.parentProcessId = process.parentProcessId;
  output.uniqueCode = process.uniqueCode;
  output.state = process.state;
  output.name = process.name;
  output.description = process.description;

  return output;
}

//
// Generic
//
export function mapToCopilotGeneric(
  conversation: CopilotConversation,
  sessionId?: number,
  contextKey?: string,
  entityRef?: CopilotPanelEntityRef,
  selectedDocument?: CopilotSelectedDocument,
  instructionExternalId?: string,
  activeField?: CopilotActiveField,
  skill?: string,
  answeredQuestionSetId?: string,
  scene?: string,
  sessionTitle?: string,
  activeProcess?: CopilotActiveProcessContext,
): CopilotGenericContentDTO {
  const output = new CopilotGenericContentDTO();
  output.sessionId = sessionId;
  output.contextKey = contextKey;
  output.entityType = entityRef?.entityType;
  output.entityId = entityRef?.entityId;
  output.conversation = mapToCopilotConversation(conversation);
  output.selectedDocument = mapToCopilotSelectedDocument(selectedDocument);
  output.instructionExternalId = instructionExternalId;
  output.activeField = activeField ? mapToCopilotActiveField(activeField) : undefined;
  output.skill = skill;
  output.answeredQuestionSetId = answeredQuestionSetId;
  output.scene = scene;
  output.sessionTitle = sessionTitle;
  output.activeProcess = activeProcess ? mapToCopilotActiveProcess(activeProcess) : undefined;

  return output;
}

function mapToCopilotActiveProcess(activeProcess: CopilotActiveProcessContext): CopilotActiveProcessDTO {
  const output = new CopilotActiveProcessDTO();
  output.processId = activeProcess.processId;
  output.key = activeProcess.key;
  output.entityId = activeProcess.entityId;

  return output;
}

// The entity of the field is the entity ref of the request; only the field name and its text travel here.
function mapToCopilotActiveField(activeField: CopilotActiveField): CopilotActiveFieldDTO {
  const output = new CopilotActiveFieldDTO();
  output.field = activeField.field;
  output.text = activeField.text;

  return output;
}

export function mapFromCopilotGeneric(item: CopilotGenericContentDTO): CopilotGenericContent {
  const output = new CopilotGenericContent();
  output.sessionId = item.sessionId;
  output.contextKey = item.contextKey;
  output.conversation = mapFromCopilotConversation(item.conversation);
  output.selectedDocument = mapFromCopilotSelectedDocument(item.selectedDocument);
  output.instructionExternalId = item.instructionExternalId;

  return output;
}

export function mapFromAITaskSessionDetail(item: AITaskSessionDetailDTO): CopilotGenericContent {
  const output = new CopilotGenericContent();
  output.sessionId = item.sessionId;
  output.contextKey = item.contextKey;
  output.conversation = mapFromCopilotConversation(item.conversation ?? new CopilotConversationDTO());
  output.conversation.pendingQuestionBlockId =
    item.status === AITaskSessionStatus.WaitingForAnswer ? item.pendingQuestionBlockId : undefined;
  output.approvals = item.approvals?.map(mapFromAITaskSessionApproval) ?? [];
  output.originField = mapFromCopilotFieldRef(item.originField);

  return output;
}

export function mapFromCopilotFileLibrarySaveResult(
  item: CopilotFileLibrarySaveResultDTO,
): CopilotFileLibrarySaveResult {
  const output = new CopilotFileLibrarySaveResult();
  output.linkId = item.linkId ?? 0;
  output.listId = item.listId ?? 0;
  output.linkName = item.linkName ?? '';
  output.folderName = item.folderName ?? undefined;
  output.fileName = item.fileName ?? undefined;

  return output;
}

function mapFromCopilotFieldRef(item: CopilotFieldRefDTO | undefined): CopilotFieldRef | undefined {
  if (!item) return undefined;

  return { entityType: item.entityType as EntityTypes, entityId: item.entityId, field: item.field };
}

function mapFromAITaskSessionApproval(item: AITaskSessionApprovalDTO): AITaskSessionApproval {
  const output = new AITaskSessionApproval();
  output.sessionId = item.sessionId;
  output.approvalId = item.approvalId;
  output.status = item.status;
  output.adaptiveCardBlockId = item.adaptiveCardBlockId;

  return output;
}

function mapToCopilotSelectedDocument(
  item: CopilotSelectedDocument | undefined,
): CopilotSelectedDocumentDTO | undefined {
  if (!item) return undefined;

  const output = new CopilotSelectedDocumentDTO();
  output.contentBlockId = item.contentBlockId;
  output.version = item.version;
  output.title = item.title;
  output.isDocumentEditorSession = item.isDocumentEditorSession;
  output.documentEditMode = item.documentEditMode;
  output.selectionText = item.selectionText;
  output.selectionStartBlockId = item.selectionStartBlockId;
  output.selectionStartOffset = item.selectionStartOffset;
  output.selectionEndBlockId = item.selectionEndBlockId;
  output.selectionEndOffset = item.selectionEndOffset;

  return output;
}

function mapFromCopilotSelectedDocument(
  item: CopilotSelectedDocumentDTO | undefined,
): CopilotSelectedDocument | undefined {
  if (!item) return undefined;

  const output = new CopilotSelectedDocument();
  output.contentBlockId = item.contentBlockId;
  output.version = item.version;
  output.title = item.title;
  output.isDocumentEditorSession = item.isDocumentEditorSession;
  output.documentEditMode = item.documentEditMode;
  output.selectionText = item.selectionText;
  output.selectionStartBlockId = item.selectionStartBlockId;
  output.selectionStartOffset = item.selectionStartOffset;
  output.selectionEndBlockId = item.selectionEndBlockId;
  output.selectionEndOffset = item.selectionEndOffset;

  return output;
}

export function mapFromAITaskSessionSummary(item: AITaskSessionSummaryDTO): AITaskSessionSummary {
  const output = new AITaskSessionSummary();
  output.sessionId = item.sessionId;
  output.status = item.status as AITaskSessionStatus;
  output.title = item.title;
  output.lastQuestion = item.lastQuestion;
  output.contextKey = item.contextKey;
  output.created = fromApiDateTimeOptional(item.created);
  output.modified = fromApiDateTimeOptional(item.modified);
  output.lastActivity = fromApiDateTimeOptional(item.lastActivity);
  output.completed = fromApiDateTimeOptional(item.completed);
  output.canceled = fromApiDateTimeOptional(item.canceled);
  output.originField = mapFromCopilotFieldRef(item.originField);

  return output;
}

export function mapFromPromptResponseCitations(
  citations: PromptResponseCitationDTO[] | undefined,
): PromptResponseCitation[] {
  if (!citations) return [];

  return citations.map((c) => {
    const output = new PromptResponseCitation();
    output.title = c.title;
    output.uri = c.uri;

    return output;
  });
}

//
// ProcessingActivity
//
export function mapToCopilotProcessingActivity(
  copilotProcessingActivity: CopilotProcessingActivity,
  privacyFramework: PrivacyFramework,
): CopilotProcessingActivityDTO {
  const output = new CopilotProcessingActivityDTO(privacyFramework);
  output.conversation = mapToCopilotConversation(copilotProcessingActivity.conversation);
  output.processingActivityId = copilotProcessingActivity.processingActivityId;

  return output;
}

export function mapFromCopilotProcessingActivity(item: CopilotProcessingActivityDTO): CopilotProcessingActivity {
  const output = new CopilotProcessingActivity();
  output.conversation = mapFromCopilotConversation(item.conversation);
  output.processingActivityId = item.processingActivityId;

  return output;
}

//
// Question options (lookup questions)
//
export function mapFromCopilotQuestionOption(dto: CopilotQuestionOptionDTO): CopilotQuestionOption {
  const output = new CopilotQuestionOption();
  // the id travels verbatim: numeric for records, a guid for users, roles and groups
  output.id = String(dto.id);
  output.label = dto.label;
  output.description = dto.description;

  return output;
}

//
// Context proposal
//

const isContextProposalKind = (kind: unknown): kind is CopilotContextProposalKind =>
  typeof kind === 'string' && Object.prototype.hasOwnProperty.call(copilotContextProposalKinds, kind);

const isControlOrRequirement = (type: number | undefined) =>
  type === EntityTypes.Control || type === EntityTypes.Requirement;

// The payload of a ContextProposal block. An item is kept only when its kind is known and its entity type is the one the
// kind stands for (a requirement and a control may both arrive as either), so the task never takes an id of another type.
// Undefined for a payload that is no proposal.
export function mapFromCopilotContextProposalPayload(payload: unknown): CopilotContextProposal | undefined {
  if (!payload || typeof payload !== 'object') return undefined;

  const dto = payload as CopilotContextProposalPayloadDTO;
  const output = new CopilotContextProposal();

  for (const itemDTO of Array.isArray(dto.items) ? dto.items : []) {
    if (!itemDTO || !isContextProposalKind(itemDTO.kind)) continue;
    if (typeof itemDTO.entityId !== 'number' || itemDTO.entityId <= 0) continue;

    const entityType = copilotContextProposalKinds[itemDTO.kind];
    if (
      itemDTO.entityType !== entityType &&
      !(isControlOrRequirement(itemDTO.entityType) && isControlOrRequirement(entityType))
    ) {
      continue;
    }

    const item = new CopilotContextProposalItem();
    item.entityType = entityType;
    item.entityId = itemDTO.entityId;
    item.kind = itemDTO.kind;
    item.code = itemDTO.code || undefined;
    item.name = itemDTO.name ?? '';
    item.reason = itemDTO.reason ?? '';
    output.items.push(item);
  }

  for (const refusalDTO of Array.isArray(dto.refused) ? dto.refused : []) {
    if (!refusalDTO) continue;

    const refusal = new CopilotContextProposalRefusal();
    refusal.name = refusalDTO.name ?? '';
    refusal.kind = refusalDTO.kind ?? '';
    refusal.entityType = isContextProposalKind(refusal.kind)
      ? copilotContextProposalKinds[refusal.kind]
      : copilotContextRefusalKinds[refusal.kind.toLowerCase()];
    refusal.reason = refusalDTO.reason ?? '';
    output.refused.push(refusal);
  }

  return output;
}
